<template>
	<div class="w-100">
		<el-select remote-show-suffix filterable clearable :style="{'width': `${width}`}" :disabled="disabled" :size="size"
			v-model="RoadwayId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder" @change="RoadwayChange"
			@clear="RoadwayClear">
			<el-option v-for="v in RoadwayList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
		</el-select>
	</div>
</template>

<script lang="ts" setup>
	import { ref, getCurrentInstance, defineEmits, defineProps, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		placeholder ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
		WarehouseId ?: string | number,
		AreaId ?: string | number,
	};

	const props = withDefaults(defineProps<main>(), {
		id: "",
		size: "default",
		placeholder: "请选择巷道",
		ValueKey: "value",
		LabelKey: "label",
		width: "100%",
		disabled: false,
		IsAuto: false,
		WarehouseId: "",
		AreaId: "",
	});

	const { proxy } = getCurrentInstance() as any;
	const emits = defineEmits(["update:id", "change", "clear"]);
	const RoadwayId = ref<any>("");
	const RoadwayList = ref<any>([]);
	const loading = ref(false);

	watch(() => props.id, (n : any) => {
		RoadwayId.value = n;
	});

	onMounted(() => {
		RoadwayId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshRoadway) {
				GetData();
			} else {
				if (proxy.$store.state.RoadwayInfo) {
					if (proxy.$store.state.RoadwayInfo.wid == props.WarehouseId && proxy.$store.state.RoadwayInfo.aid == props.AreaId) {
						RoadwayList.value = proxy.$store.state.RoadwayInfo.list;
					} else {
						GetData();
					}
				} else {
					GetData();
				}
			}
		}
	});

	const RoadwayChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const RoadwayClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshRoadway) {
			GetData();
		} else {
			if (proxy.$store.state.RoadwayInfo) {
				if (proxy.$store.state.RoadwayInfo.wid == props.WarehouseId && proxy.$store.state.RoadwayInfo.aid == props.AreaId) {
					RoadwayList.value = proxy.$store.state.RoadwayInfo.list;
				} else {
					GetData();
				}
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		loading.value = true;
		proxy.$api.tokenRequest({
			url: '/admin/warehouse/listByType',
			data: {
				type: 3,
				warehouse_id: props.WarehouseId,
				area_id: props.AreaId,
				is_page: 0,
			},
			success: (res : any) => {
				loading.value = false;
				RoadwayList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 9,
					wid: props.WarehouseId,
					aid: props.AreaId,
					list: res.data,
				});
			},
			fail: () => {
				loading.value = false;
			},
		});
	};
</script>

<style>
</style>